import images from "./images";
import cardgo from "../1.png";
const services = [
  {
    image: `${images.services_img_1}`,
    title: "Front End Development",
    paragraph:
      "I specialize in crafting visually engaging and user-friendly websites that leave a lasting impression on your audience. Using cutting-edge technologies like HTML5, CSS3, and JavaScript, I ensure your website delivers a seamless user experience across all devices.",
  },
  {
    image: `${images.services_img_2}`,
    title: "Responsive Design",
    paragraph:
      "With mobile usage on the rise, having a responsive website is crucial. I create designs that adapt flawlessly to different screen sizes, guaranteeing that your site looks stunning and functions perfectly on smartphones, tablets, and desktops.",
  },
  {
    image: `${images.services_img_3}`,
    title: "Performance Optimization",
    paragraph:
      "A fast-loading website is essential for retaining visitors and improving SEO rankings. I implement performance optimization techniques to boost your site's speed, delivering a seamless experience to your users.",
  },
  {
    image: `${images.services_img_4}`,
    title: "Interactive User Interfaces",
    paragraph:
      "I am proficient in developing interactive and intuitive user interfaces that captivate your visitors. Through dynamic elements and smooth animations, I enhance user engagement, making your website a pleasure to navigate.",
  },
  {
    image: `${images.services_img_5}`,
    title: "Cross-Browser Compatibility",
    paragraph:
      "Worried about your website's performance on various browsers? Fear not! I optimize your site to run smoothly on all major browsers, ensuring consistent functionality and aesthetics across the board.",
  },
  {
    image: `${images.services_img_6}`,
    title: "Continuous Support and Maintenance",
    paragraph:
      "My services don't end after the development phase. I provide continuous support and maintenance to keep your website running smoothly and up-to-date with the latest trends and technologies.",
  },
];

const works = [
  {
    id: 1,
    name: "Audio Pleer",
    image: "https://i.ibb.co/bHGpKKk/2023-07-13-00-48-36.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 2,
    name: "Car Online Shop",
    image: "https://i.ibb.co/LzsZHD9/2023-07-13-00-57-18.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 3,
    name: "Game",
    image: "https://i.ibb.co/xXhr5Jj/2023-07-13-00-43-40.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 4,
    name: "News",
    image: "https://i.ibb.co/3TBfk1p/2023-07-13-00-34-04.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 5,
    name: "Dashboard",
    image: "https://i.ibb.co/HtcQmDC/2023-07-13-00-40-52.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 6,
    name: "chat",
    image: "https://i.ibb.co/7R7qsps/2023-07-13-00-30-17.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 7,
    name: "Cap Online Shop",
    image: "https://i.ibb.co/tZYrnB5/Cap-online.png",
    disp: " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 8,
    name: "React pizza",
    image:
      "https://camo.githubusercontent.com/d3aaa4d032d0165c3bd0a808df53a2a5d522fa28ff43ae59438542bece73871d/68747470733a2f2f696d6775722e636f6d2f5275776d6136672e6a7067",
    disp: "lorem femfkdslmf dlf dlsfn sfd sdfn sdfn sdfn skfnskdnf ksdfn skfnsdkfn",
  },
  {
    id: 9,
    name: "TECH shop",
    image: "https://i.ibb.co/yF9WnPR/2023-07-13-13-52-19.png",
    disp: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 9,
    name: "Amazing Landing",
    image: cardgo,
    disp: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 10,
    name: "Dashboard",
    image:
      "https://hhcdn.ru/photo/733380884.png?t=1693580311&h=Bh3D4KgzFChgstMvDL31xw",
    disp: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 11,
    name: "Landing And",
    image: "https://i.ibb.co/XSZZ2dB/2023-07-13-14-10-05.png",
    disp: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
  {
    id: 12,
    name: "Landing And",
    image: "https://reactjsexample.com/content/images/2022/07/56e2e706e67.png",
    disp: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus itaque velit similique eum id delectus minima! Corrupti ea earum itaque saepe. Doloremque, officiis amet. Deserunt laborum culpa sit reiciendis! Perspiciatis!",
  },
];

const work_process = [
  {
    title: "Sketch",
    paragraph: "Nunc sodales lacus nec felis suscipit dictum",
  },
  {
    title: "Design",
    paragraph: "Nunc sodales lacus nec felis suscipit dictum",
  },
  {
    title: "Develop",
    paragraph: "Nunc sodales lacus nec felis suscipit dictum",
  },
  {
    title: "End-Product",
    paragraph: "Nunc sodales lacus nec felis suscipit dictum",
  },
];

const about_stats = [
  {
    image: `${images.stat_img_1}`,
    value: "1575",
    title: "Clients",
  },
  {
    image: `${images.stat_img_2}`,
    value: "2416",
    title: "Projects",
  },
  {
    image: `${images.stat_img_3}`,
    value: "4287",
    title: "Working Hours",
  },
  {
    image: `${images.stat_img_4}`,
    value: "287",
    title: "Awards",
  },
];

const testimonials = [
  {
    name: "Lelia Merritt",
    post: "Graphic Designer",
    paragraph:
      "Aliquam et odio arcu. Vestibulum pharetra tincidunt odio, sed pulvinar magna tempus quis. Mauris risus odio, semper sit amet tortor a, tristique consectetur urna.",
  },
  {
    name: "John Huston",
    post: "Web Developer",
    paragraph:
      "Aliquam et odio arcu. Vestibulum pharetra tincidunt odio, sed pulvinar magna tempus quis. Mauris risus odio, semper sit amet tortor a, tristique consectetur urna.",
  },
  {
    name: "Jeniffer Green",
    post: "Marketing Manager",
    paragraph:
      "Aliquam et odio arcu. Vestibulum pharetra tincidunt odio, sed pulvinar magna tempus quis. Mauris risus odio, semper sit amet tortor a, tristique consectetur urna.",
  },
];

const logos = [
  {
    id: 1,
    name: "TypeScript",
    image: "https://cdn-icons-png.flaticon.com/512/5968/5968381.png",
  },
  {
    id: 2,
    name: "JavaScript",
    image: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
  },
  {
    id: 3,
    name: "React",
    image:
      "https://cdn.iconscout.com/icon/free/png-256/free-react-1-282599.png?f=webp",
  },
  {
    id: 4,
    name: "Next.js",
    image: "https://devarticles.in/wp-content/uploads/2021/10/nextjs-log.jpeg",
  },
  {
    id: 5,
    name: "Docker",
    image:
      "https://www.docker.com/wp-content/uploads/2022/03/vertical-logo-monochromatic.png",
  },
  {
    id: 6,
    name: "Nginx",
    image:
      "https://www.mabl.com/hubfs/CICDBlog.png",
  },
  {
    id: 7,
    name: "Sass",
    image: "https://cdn-icons-png.flaticon.com/512/5968/5968358.png",
  },
  {
    id: 8,
    name: "Antd",
    image:
      "https://static-00.iconduck.com/assets.00/ant-design-icon-1024x1023-8uckm0lb.png",
  },
  {
    id: 9,
    name: "Tailwind",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2048px-Tailwind_CSS_Logo.svg.png",
  },
  {
    id: 10,
    name: "Node.js",
    image: "https://cdn-icons-png.flaticon.com/512/919/919825.png",
  },
  {
    id: 11,
    name: "PHP",
    image: "https://www.svgrepo.com/show/452088/php.svg",
  },
  // {
  //   id: 12,
  //   name: "GO",
  //   image:
  //     "https://static4.tgstat.ru/channels/_0/de/defd45f83df9a62166df4bdbd0a1ce2b.jpg",
  // },
  {
    id: 13,
    name: "Redux-Toolkit",
    image:
      "https://img.uxwing.com/wp-content/themes/uxwing/download/brands-social-media/redux-icon.png",
  },
  // {
  //   id: 14,
  //   name: "Pithon",
  //   image:
  //     "https://static-00.iconduck.com/assets.00/python-icon-512x512-48og66bp.png",
  // },
  // {
  //   id: 15,
  //   name: "django",
  //   image: "https://www.svgrepo.com/show/353657/django-icon.svg",
  // },
  {
    id: 16,
    name: "Git",
    image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
  },
  {
    id: 17,
    name: "GitHub",
    image: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
  },
  {
    id: 18,
    name: "GitLab",
    image: "https://cdn-icons-png.flaticon.com/512/5968/5968853.png",
  },
  {
    id: 19,
    name: "Jest",
    image:
      "https://static-00.iconduck.com/assets.00/jest-icon-1795x2048-6qrlxpcx.png",
  },
];

export { services, works, work_process, about_stats, testimonials, logos };
